/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getBooleanDecoder,
  getBooleanEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";
import {
  getMultisigTypeDecoder,
  getMultisigTypeEncoder,
  type MultisigType,
  type MultisigTypeArgs,
} from ".";

/** Metadata and requirements for each MultisigType */
export type MultisigTypeConfig = {
  /** The multisig type */
  multisigType: MultisigType;
  /** Required timelock duration in seconds (0 = no timelock) */
  timelockSeconds: bigint;
  /** Minimum number of signers allowed */
  minSigners: number;
  /** Maximum number of signers allowed */
  maxSigners: number;
  /** Minimum reputation score required (0-10000 basis points) */
  minReputationScore: number;
  /** Whether signers must hold governance tokens */
  requiresTokenHoldings: boolean;
  /** Minimum token balance required (if requires_token_holdings) */
  minTokenBalance: bigint;
};

export type MultisigTypeConfigArgs = {
  /** The multisig type */
  multisigType: MultisigTypeArgs;
  /** Required timelock duration in seconds (0 = no timelock) */
  timelockSeconds: number | bigint;
  /** Minimum number of signers allowed */
  minSigners: number;
  /** Maximum number of signers allowed */
  maxSigners: number;
  /** Minimum reputation score required (0-10000 basis points) */
  minReputationScore: number;
  /** Whether signers must hold governance tokens */
  requiresTokenHoldings: boolean;
  /** Minimum token balance required (if requires_token_holdings) */
  minTokenBalance: number | bigint;
};

export function getMultisigTypeConfigEncoder(): FixedSizeEncoder<MultisigTypeConfigArgs> {
  return getStructEncoder([
    ["multisigType", getMultisigTypeEncoder()],
    ["timelockSeconds", getI64Encoder()],
    ["minSigners", getU8Encoder()],
    ["maxSigners", getU8Encoder()],
    ["minReputationScore", getU16Encoder()],
    ["requiresTokenHoldings", getBooleanEncoder()],
    ["minTokenBalance", getU64Encoder()],
  ]);
}

export function getMultisigTypeConfigDecoder(): FixedSizeDecoder<MultisigTypeConfig> {
  return getStructDecoder([
    ["multisigType", getMultisigTypeDecoder()],
    ["timelockSeconds", getI64Decoder()],
    ["minSigners", getU8Decoder()],
    ["maxSigners", getU8Decoder()],
    ["minReputationScore", getU16Decoder()],
    ["requiresTokenHoldings", getBooleanDecoder()],
    ["minTokenBalance", getU64Decoder()],
  ]);
}

export function getMultisigTypeConfigCodec(): FixedSizeCodec<
  MultisigTypeConfigArgs,
  MultisigTypeConfig
> {
  return combineCodec(
    getMultisigTypeConfigEncoder(),
    getMultisigTypeConfigDecoder(),
  );
}
